import type { IAvatarBlockProps } from './AvatarBlock'

import { styled } from '@linaria/react'
import {
  AvatarBlockAlignItems,
  AvatarBlockDirection,
  AvatarBlockJustifyContent,
} from './AvatarBlock.h'

export const AvatarBlockStyled = styled.div<
  Omit<IAvatarBlockProps, 'children'>
>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  display: inline-flex;
  flex-direction: ${({ direction }) => direction || AvatarBlockDirection.Row};
  justify-content: ${({ justifyContent }) =>
    justifyContent || AvatarBlockJustifyContent.FlexStart};
  align-items: ${({ alignItems }) =>
    alignItems || AvatarBlockAlignItems.FlexStart};
  padding: ${({ padding }) =>
    padding && padding.length > 0
      ? padding.map((item) => `var(${item})`)?.join(' ')
      : 0};
  border-radius: ${({ corners }) => (corners ? `var(${corners})` : 0)};
  row-gap: ${({ rowGap }) => `var(${rowGap?.[0]})`};
  column-gap: ${({ columnGap }) => `var(${columnGap?.[0]})`};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
`
